import { useEffect } from 'react'
import { useNotificaciones } from '../hooks/useNotificaciones'
import { useTareasQuery } from '../hooks/useTareasQueries'
import { useHabitosQuery } from '../hooks/useHabitosQueries'
import api from '../api'

export default function NotificacionesManager() {
  const { programarRecordatorioTareas, programarRecordatorioHabitos, pedirPermiso, notificarAhora } = useNotificaciones()
  const { data: tareas = [] } = useTareasQuery()
  const { data: habitos = [] } = useHabitosQuery()

  useEffect(() => {
    pedirPermiso()
  }, [])

  useEffect(() => {
    if (tareas.length > 0) programarRecordatorioTareas(tareas)
  }, [tareas])

  useEffect(() => {
    if (habitos.length > 0) programarRecordatorioHabitos(habitos)
  }, [habitos])

  // Verificar logros cada vez que cambian tareas o hábitos
  useEffect(() => {
    if (tareas.length > 0 || habitos.length > 0) {
      api.verificarLogros().then(nuevos => {
        if (Array.isArray(nuevos) && nuevos.length > 0) {
          nuevos.forEach(l => {
            notificarAhora(
              `🏆 ¡Logro desbloqueado!`,
              `${l.emoji} ${l.nombre} — ${l.descripcion}`
            )
          })
        }
      }).catch(() => {})
    }
  }, [tareas.length, habitos.length])

  return null
}